export default {
  genericParagraph: {
    id: 'outlet_intro_paragraph',
    defaultMessage:
      "Professionally inspected refurbished devices in perfect working condition. The only reason they're priced low is because they don't look brand new. They have scratches or dents. If you care more about how something works rather than how it looks, you're in the right spot. Every device comes with a 1-year warranty, 30-day returns, and customer care.",
  },
  iphoneHeadline: {
    id: 'outlet_intro_iphone_headline',
    defaultMessage:
      'Professionally inspected refurbished iPhones in perfect working condition.',
  },
  iphoneBody: {
    id: 'outlet_intro_iphone_body',
    defaultMessage:
      "The only reason they're priced low is because they don't look brand new. They have scratches or dents. If you care more about how something works rather than how it looks, you're in the right spot. Every iPhone comes with a 1-year warranty, 30-day returns, customer care, and free phone case.",
  },
  macbookHeadline: {
    id: 'outlet_intro_macbook_headline',
    defaultMessage:
      'Professionally inspected refurbished MacBooks in perfect working condition.',
  },
  macbookBody: {
    id: 'outlet_intro_macbook_body',
    defaultMessage:
      "The only reason they're priced low is because they don't look brand new. They have scratches or dents. If you care more about how something works rather than how it looks, you're in the right spot. Every MacBook comes with a 1-year warranty, 30-day returns, and customer care.",
  },
  dismiss: {
    id: 'outlet_intro_dismiss',
    defaultMessage: 'Dismiss',
  },
}
